<template>
  <button ref="buttonRef" type="button">
    <slot />
  </button>
</template>

<script lang="ts" setup>
import { onMounted, toRefs, ref } from "vue";

interface SingleSelectOptionProps {
  autoFocus?: boolean;
}

const props = defineProps<SingleSelectOptionProps>();

const { autoFocus } = toRefs(props);

const buttonRef = ref<HTMLButtonElement | null>(null);

onMounted(() => {
  if (autoFocus.value && buttonRef.value) {
    buttonRef.value.focus();
  }
});

defineExpose({ buttonRef });
</script>
